var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNexoNexoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.48 42.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nexo-logo-03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.84,0.28l24.26,14V28.56L0,7.14,11.89,0.28A1,1,0,0,1,12.84.28Z",
    style: {
      fill: "#3ca9e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.1 0 24.73 7.14 37.1 14.28 37.1 0",
    style: {
      fill: "#2853c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,0L49,6.86a1,1,0,0,1,.48.83v28L37.1,28.56V0Z",
    style: {
      fill: "#1a4199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.47,35.7L37.58,42.56a1,1,0,0,1-1,0l-24.25-14V14.26Z",
    style: {
      fill: "#2853c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.14v28A1,1,0,0,0,.48,36l11.89,6.86V14.26Z",
    style: {
      fill: "#60beff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.37 42.84 24.73 35.7 12.37 28.56 12.37 42.84",
    style: {
      fill: "#3ca9e5"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexoNexoLogo);
export default __webpack_public_path__ + "static/media/nexo-nexo-logo.6736cd4f.svg";
export { ForwardRef as ReactComponent };